import { render, staticRenderFns } from "./ManageSkillPage.vue?vue&type=template&id=107060fa&"
import script from "./ManageSkillPage.vue?vue&type=script&lang=js&"
export * from "./ManageSkillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports